import { useEffect } from 'react';

import type {
  LegacyMobileAppToWebEvents,
  MobileAppToWebEvents,
  SubscribeToPushNotifications,
  UnsubscribeFromPushNotifications,
} from '@app/types/crossPlatformEvents';

type WindowMessageData = {
  eventType?: string;
  type?: string;
  data?: any;
};

export const useMobileEventHandler = (dependencies: MobileMessageHandlerDependencies) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent<WindowMessageData>) => {
      mobileMessageHandler(event.data, dependencies);
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dependencies]);
};

type MobileMessageHandlerDependencies = {
  receivePushNotificationStatus: (data: boolean) => void;
  subscribeToPushNotifications: (data: SubscribeToPushNotifications['data']) => void;
  unsubscribeToPushNotifications: (data: UnsubscribeFromPushNotifications['data']) => void;
};

const mobileMessageHandler = (message: WindowMessageData, dependencies: MobileMessageHandlerDependencies) => {
  const { type, data } = {
    type: message.type ?? message.eventType ?? null,
    data: message.data,
  } as MobileAppToWebEvents | LegacyMobileAppToWebEvents;

  if (!type) {
    return;
  }

  switch (type) {
    case 'subscribe-to-push-notifications':
      dependencies.subscribeToPushNotifications(data);
      break;
    case 'unsubscribe-from-push-notifications':
      dependencies.unsubscribeToPushNotifications(data);
      break;
    // Legacy events
    case 'PushNotification':
      dependencies.receivePushNotificationStatus(data);
      break;
  }
};
